import React, { useEffect, useState, useRef } from 'react';
import * as _ from 'lodash';
import Tyre from "./Tyre";

export default function Tyres(props) {
  const [tyres, setTyres] = useState(props.tyres);
  useEffect(() => {
    document.getElementsByName(props.fieldName)[0].value = JSON.stringify(tyres);
  }, [tyres]);
  return (<div>
    {_.map(tyres, (tyre, id) =>
      <Tyre
        config={props.config}
        tyre={tyre}
        legend={<>Opona {parseInt(id) + 1}
          {parseInt(id) > 0 && <>{' '}
            <a onClick={() => {
              const newTyres = Object.assign([], tyres);
              newTyres.splice(id, 1);
              setTyres(newTyres);
              return;
            }
            }>(usuń)</a>
          </>}
        </>}
        onChange={(val, field) => {
          const newTyres = Object.assign([], tyres);
          newTyres[id][field] = val;
          setTyres(newTyres);
          return;
        }}
      />)}

    <a className="button" onClick={() => {
      const newTyres = Object.assign([], tyres);
      newTyres.push(tyres.length > 0 ? Object.assign({}, tyres[tyres.length - 1], { id: null }) : {
        type: 'W',
        location: 'FL',
        cap: 0
      });
      setTyres(newTyres);
      return;
    }}>Dodaj oponę
    </a>
  </div>);
}
